/* eslint-disable import/no-default-export */
import { Storage } from '@trello/storage';
import { createReducer } from '@trello/redux';

export interface LabelUiState {
  showText: boolean;
}

const initialState: LabelUiState = Storage.get('labelState') || {
  showText: false,
};

export default createReducer(initialState, {
  // TODO: Sync this state with classic in real-time
});
